import { PANELS } from '../constant'
import { CompanyAlerts } from './companyAlerts'
import { CompanyOverview } from './companyOverview'
import { FilingStatus } from './filingStatus'
import { KeyFinancials } from './keyFinancials'
import { OwnershipAndGroup } from './ownershipAndGroup'
import { RecentNews } from './recentNews'
import { Score } from './score'
import { TopIndustryPlayers } from './topIndustryPlayers'

export const getContentPanel = (key, panelType) => {
  switch (key) {
    case PANELS.COMPANY_OVERVIEW:
      return <CompanyOverview />
    case PANELS.OWNERSHIP_AND_GROUP:
      return <OwnershipAndGroup />
    case PANELS.KEY_FINANCIALS:
      return <KeyFinancials panelType={panelType} />
    case PANELS.SCORE:
      return <Score />
    case PANELS.RECENT_NEWS:
      return <RecentNews />
    case PANELS.COMPANY_ALERTS:
      return <CompanyAlerts />
    case PANELS.TOP_INDUSTRY_PLAYERS:
      return <TopIndustryPlayers />
    case PANELS.FILING_STATUS:
      return <FilingStatus />
    default:
      return <></>
  }
}
